import React from "react";
import {
  ShieldCheck, BrainCircuit, ClipboardList, BarChart3, Lock,
  MonitorCheck, MessageSquare, GraduationCap, Building2, Users, Zap,
} from "lucide-react";
import { C, Reveal, CountUp, Stat } from "./shared";

const CAPABILITIES = [
  [ShieldCheck, "Verified Credentials"],
  [BrainCircuit, "AI-Powered Matching"],
  [ClipboardList, "Application Tracking"],
  [BarChart3, "Analytics & Reporting"],
  [Lock, "Secure Data & Privacy"],
  [MonitorCheck, "Role-based Dashboards"],
  [MessageSquare, "Integrated Communications"],
  [GraduationCap, "Structured Skill Pathways"],
];

export default function CapabilitiesAndImpact() {
  return (
    <section className="bg-white border-t" style={{ borderColor: C.rule }}>
      <div className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-7">
          <div className="rounded-2xl p-8" style={{ background: C.paper, border: `1px solid ${C.rule}` }}>
            <h3 className="font-display font-extrabold text-xl tracking-wide uppercase" style={{ color: C.navy }}>
              Powerful Platform Capabilities
            </h3>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-6">
              {CAPABILITIES.map(([Icon, label], i) => (
                <div key={label} className="group text-center cursor-default" data-testid={`cap-${i}`}>
                  <div className="mx-auto w-12 h-12 rounded-lg grid place-items-center transition-all duration-300 group-hover:scale-110 group-hover:-translate-y-1 group-hover:shadow-lg"
                    style={{ background: "white", border: `1px solid ${C.rule}`, color: C.navy }}>
                    <Icon size={20} strokeWidth={2} className="transition-transform duration-500 group-hover:rotate-12" />
                  </div>
                  <div className="mt-2 text-xs font-semibold transition-colors duration-300 group-hover:text-signal" style={{ color: C.ink }}>{label}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={2} id="impact" className="lg:col-span-5">
          <div className="rounded-2xl p-6 sm:p-8 h-full" style={{ background: C.paper, border: `1px solid ${C.rule}` }}>
            <h3 className="font-display font-extrabold text-xl tracking-wide uppercase" style={{ color: C.navy }}>
              Built for Impact
            </h3>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-5">
              <Stat icon={Building2} value={<><CountUp value={5} suffix="+" /></>} label="Pilot Campuses" color={C.navy} />
              <Stat icon={Users} value={<>15–<CountUp value={20} /></>} label="Active Employers" color={C.green} />
              <Stat icon={GraduationCap} value={<><CountUp value={10000} suffix="+" format="comma" /></>} label="Student Profiles" color={C.green} />
              <Stat icon={ClipboardList} value={<><CountUp value={40} suffix="%+" /></>} label="Profile Completion" color={C.navy} />
              <Stat icon={ShieldCheck} value={<><CountUp value={20} suffix="%+" /></>} label="Verified Credentials" color={C.green} />
              <Stat icon={Zap} value={<>&lt;<CountUp value={72} suffix="h" /></>} label="Shortlist Time" color={C.orange} />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
